import loadBefore from "@/javascript/components/load"
import $ from "jquery"

const selectsIds = {
  jobCategories: 'search_job_category_ids',
  certifications: 'search_certification_ids',
  industries: 'search_industry_ids',
  country: 'search_country_code',
  skills: 'search_skill_ids',
  workedAt: 'search_worked_at_ids'
}

const fieldsIds = {
  budget: 'search_budget',
  page: 'search_page',
  radius: 'search_radius',
  location: 'search_location'
}

const cvPhrasesId = 'search_cv_query'
const excludeNotLookingId = 'search_exclude_not_looking'
const activeWithinLastYearId = 'search_active_within_last_year'
const includeUnapprovedId = 'search_include_unvetted'

window.selects = {}
window.fields = {}

const performSearch = (options = {}) => {
  // TODO: Should it get the required skill IDs via the SkilLSelect API?
  const required_skill_ids = []
  if(options.requireSkill) {
    required_skill_ids.push(options.requireSkill)
  }

  document.querySelectorAll('[name="required_skill_ids"]:checked').forEach((checkbox) => {
    required_skill_ids.push(checkbox.value)
  })

  const params = {
    job_category_ids: selects.jobCategories.getValue().join(','),
    skill_ids: selects.skills.getValue().join(','),
    required_skill_ids: required_skill_ids.join(','),
    industry_ids: selects.industries.getValue().join(','),
    certification_ids: selects.certifications.getValue().join(','),
    budget: fields.budget.value,
    country_code: selects.country.getValue(),
    worked_at_ids: selects.workedAt.getValue().join(','),
    page: fields.page.value,
    location: fields.location.value,
    radius: fields.radius.value
  }

  if(!document.getElementById(excludeNotLookingId).checked) {
    params.exclude_not_looking = 0
  }
  if(document.getElementById(activeWithinLastYearId)?.checked) {
    params.active_within_last_year = 1
  }
  if(document.getElementById(includeUnapprovedId)?.checked) {
    params.include_unvetted = 1
  }

  const cp_phrases_element = document.getElementById(cvPhrasesId)
  if(cp_phrases_element && cp_phrases_element.value) {
    params.cv_query = cp_phrases_element.value
  }

  location.href = `/search/results?${$.param(params)}#perform-search`
}

loadBefore(() => {
  for (const [key, id] of Object.entries(selectsIds)) {
    selects[key] = document.getElementById(id).selectize
  }
  for (const [key, id] of Object.entries(fieldsIds)) {
    fields[key] = document.getElementById(id)
  }

  document.getElementById('perform-search').addEventListener('click', (e) => {
    performSearch()
  })

  document.addEventListener('click', (e) => {
    if(!e.target.matches('.missing-requirements a[data-skill-id]')) {
      return
    }
    performSearch({requireSkill: e.target.dataset.skillId})
  })

  document.addEventListener('locationSelected', (e) => {
    fields.radius.selectize.enable()
  })

  document.addEventListener('locationRemoved', (e) => {
    fields.radius.selectize.disable()
  })
})
